// collection used by civicsUtils/collection_manager
define(function() {

    const CollectionManager = require('civicsUtils/collection_manager');
    const IpsModelCollection = require('civicsBase/ipsModelCollection');
    const builder = require('civicsUtils/buildUrlParameters');
    const IpsModel = require('civicsBase/ipsModel');

    return IpsModelCollection.extend({
        constructor: function(attributes, options) {
            if (__DEV__) console.log('generic_collection attributes options',attributes,options);

            options = options ? options : {cmOptions:{}};
            this.cm = new CollectionManager(this.dataTypeContext, options.cmOptions);

            // 2016-04-04 PL:  Call IpsModelCollection constructor passing any attributes
            IpsModelCollection.apply(this, attributes);

            // 2016-04-04 PL:  Set the idAttribute for collections (e.g.  building|1000)
            this.model = this.model.extend({
                idAttribute: '_appId'
            });
        },
        setDataTypes: function(types) {
            this.cm.setDataTypes(types);
        },
        setPassThrough: function(passThrough,value) {
            this.cm.setPassThrough(passThrough,value);
        },
        setFilter: function(filter) {
            this.cm.setFilter(filter);
        },
        setOrderBy: function(property, direction) {
            this.cm.setOrderBy(property, direction);
        },
        setSort: function(property, direction) {
            this.cm.setSort(property, direction);
        },
        setSortComparator: function(comparator) {
            this.cm.setSortComparator(comparator);
        },
        setTriggerPosition: function(position) {
            this.cm.setTriggerPosition(position);
        },
        setSelect: function(properties) {
            this.cm.setSelect(properties);
        },
        // Different ways to fetch ( from portlet )
        // 1.)
        //this.collectionManager = new CollectionManager(this.collection.dataTypeContext);
        //this.collectionManager.collection = this.collection;
        //this.collectionManager.fetchAllCollections(false);
        //
        // 2.)
        //this.collection.setOrderBy('status','asc');
        //this.collection.setSort('status','asc');
        //this.collection.fetch();
        fetch: function(options) {
            var self = this;

            var createNewCollection = options ? (typeof options.createNewCollection != 'undefined' ? options.createNewCollection : true) : true;


            // let collection manager create new instance and copy the model in the delegate
            return this.cm.fetchAllCollections(createNewCollection)
                .done(function() {
                    // Whenever you need to create a new collection or you didn't specify (default is true) then reset the collection
                    if (createNewCollection)
                         self.reset();
                    _.forEach(self.cm.collection.models, (function(eachModel) {
                        var m = new eachModel.constructor(eachModel.toJSON());
                        self.add(m)
                    }));
                    self.setClean();
                }).then();
        }
    });
});
